const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfTechnology extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfTechnology,
            "Each civilization scores 4 culture for each of its level III technologies (level II in Advanced game).",
            {}
        )
    }
}

module.exports = ImpactOfTechnology;